import { Info } from "lucide-react";
import { Button } from "@/components/ui/button";
import { InfoTooltip } from "@/components/ui/info-tooltip";
import { Switch } from "@/components/ui/switch";

interface EngagementToggleProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export function EngagementToggle({
  checked,
  onCheckedChange,
}: EngagementToggleProps) {
  return (
    <Button
      asChild
      variant="outline"
      size="sm"
      className="h-8 hover:bg-background hover:text-foreground hover:border-border"
    >
      <div className="inline-flex items-center gap-2 px-3 h-8 text-sm">
        <div className="flex items-center gap-1">
          <span className="text-xs font-medium">Include bids</span>
          <InfoTooltip
            trigger={
              <button
                type="button"
                onClick={(e) => e.stopPropagation()}
                className="inline-flex items-center justify-center"
                aria-label="Include bids information"
              >
                <Info className="h-3.5 w-3.5 text-muted-foreground transition-colors" />
              </button>
            }
            side="top"
            className="w-80"
          >
            <div className="space-y-2 text-sm">
              <p className="font-medium">Bid Inclusion Filter</p>
              <p>
                <span className="font-medium">Off (default):</span> Only shows
                activities where the customer engaged back (responded to the
                "bid"). Examples:
              </p>
              <ul className="list-disc list-inside pl-2 space-y-1">
                <li>Customer replied to an email</li>
                <li>Customer answered a phone call</li>
                <li>Both parties attended a meeting</li>
              </ul>
              <p>
                <span className="font-medium">On:</span> Shows all outreach
                activities, including "bids" without customer response.
                Examples:
              </p>
              <ul className="list-disc list-inside pl-2 space-y-1">
                <li>Email sent but not replied to</li>
                <li>Voicemail left</li>
                <li>Meeting scheduled but customer didn't attend</li>
              </ul>
            </div>
          </InfoTooltip>
        </div>
        <Switch
          id="engagement-toggle"
          checked={checked}
          onCheckedChange={onCheckedChange}
          aria-label="Toggle include bids"
          className="ml-1 data-[state=checked]:bg-primary"
        />
      </div>
    </Button>
  );
}
